<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text">
    {{ isEditMode ? "Edit Hauler Pricing" : "Add Hauler Pricing" }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
    <form
      [formGroup]="haulerPricingForm"
      class="form-grid"
    >
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Unit</mat-label>
        <mat-select
          formControlName="uom"
          (selectionChange)="findUnitTypeNameById($event.value)"
          required
          data-testId="uom"
        >
          <mat-option *ngFor="let unit of unitType" [value]="unit.id">{{
            unit.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Price</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input matInput formControlName="price" type="text" (input)="formatCurrencyPrice($event)" required
          data-testId="price" (input)="roundOff($event, 9999, 4, 0, 'price')"
        />
        <mat-error *ngIf="haulerPricingForm.get('price')?.hasError('pattern')">
          Enter a valid amount (up to 4 decimals)
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Fuel SurCharge</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input matInput formControlName="fuel_Surcharge" type="text"
          (input)="formatCurrencyFuelSurcharge($event)" required
          data-testId="fuelSurcharge" (input)="roundOff($event, 9999, 4, 0, 'fuel_Surcharge')"
        />
        <mat-error
          *ngIf="haulerPricingForm.get('fuel_Surcharge')?.hasError('pattern')"
        >
          Enter a valid amount (up to 4 decimals)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Demurrage Rate</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input matInput formControlName="demurag_Rate" type="text"
          (input)="formatCurrencyDemurrage($event)" required data-testId="demuragRate" (input)="roundOff($event, 9999, 4, 0, 'demurag_Rate')"/>
        <mat-error
          *ngIf="haulerPricingForm.get('demurag_Rate')?.hasError('pattern')"
        >
          Enter a valid amount (up to 4 decimals)
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Disposal Sites</mat-label>
        <mat-select formControlName="disposalSite" multiple>
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #disposalSiteSearchInput matInput placeholder="Search Disposal Site..." (input)="filterDisposalSite($event)"
                class="mat-select-search-input" aria-label="Search Disposal Site" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option *ngFor="let site of filteredDisposalSites()" [value]="site.sid">{{ site.siteName }}</mat-option>
        </mat-select>
      </mat-form-field>
      
      <app-select-search (selectedItemId)="onCustomerReceived($event)" [selectItems]="selectCustomerItems"
        [isrequired]="true" [matcher]="matcher" [setId]="data?.formData?.generatorId"
        [invalid]="!!(haulerPricingForm.get('generatorId')?.invalid && (haulerPricingForm.get('generatorId')?.touched || attemptSave()))"
        selectTitle="Customer"></app-select-search>
    </div>
    <div class="form-grid-row">      
      <app-select-search (selectedItemId)="onStreamReceived($event)" [selectItems]="selectStreamItems"
        [isrequired]="true" [matcher]="matcher" [setId]="data?.formData?.streamId"
        [invalid]="!!(haulerPricingForm.get('streamId')?.invalid && (haulerPricingForm.get('streamId')?.touched))"
        selectTitle="Stream"></app-select-search>
    </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-primary type="button" (click)="onCancel()">
      Cancel
    </button>
    @if(canSave){
      <button (click)="onSubmit()" mat-raised-button
        color="primary"
        mat-primary
        type="submit"
        [disabled]="haulerPricingForm.invalid"
        data-testId="btnSave"
      >
        {{ isEditMode ? "Update" : "Save" }}
      </button>
    }
  </mat-dialog-actions>
